var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnreadFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 41,
    viewBox: "0 0 55 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9983_193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7098 18.6345C52.6933 14.2612 44.7857 0 27.5603 0C10.3349 0 2.42733 14.2612 0.410817 18.6345C0.140122 19.2206 0 19.8576 0 20.5023C0 21.1469 0.140122 21.784 0.410817 22.3701C2.42733 26.7388 10.3349 41 27.5603 41C44.7857 41 52.6933 26.7388 54.7098 22.3655C54.98 21.7801 55.1198 21.1438 55.1198 20.5C55.1198 19.8562 54.98 19.2199 54.7098 18.6345ZM27.5603 36.4444C13.0749 36.4444 6.31568 24.2219 4.59314 20.5251C6.31568 16.7781 13.0749 4.55556 27.5603 4.55556C42.0113 4.55556 48.7728 16.7257 50.5275 20.5C48.7728 24.2743 42.0113 36.4444 27.5603 36.4444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5603 9.11084C25.2891 9.11084 23.0689 9.77879 21.1804 11.0302C19.2919 12.2816 17.82 14.0603 16.9509 16.1414C16.0817 18.2224 15.8543 20.5124 16.2974 22.7216C16.7405 24.9308 17.8342 26.9601 19.4402 28.5529C21.0462 30.1457 23.0924 31.2303 25.32 31.6698C27.5476 32.1092 29.8566 31.8837 31.9549 31.0217C34.0533 30.1597 35.8468 28.6999 37.1086 26.8271C38.3704 24.9542 39.0439 22.7522 39.0439 20.4997C39.0403 17.4803 37.8292 14.5856 35.6764 12.4506C33.5236 10.3155 30.6048 9.11446 27.5603 9.11084ZM27.5603 27.3331C26.1976 27.3331 24.8654 26.9323 23.7324 26.1814C22.5993 25.4306 21.7162 24.3634 21.1947 23.1147C20.6732 21.8661 20.5367 20.4921 20.8026 19.1666C21.0684 17.8411 21.7247 16.6235 22.6883 15.6678C23.6519 14.7122 24.8796 14.0614 26.2161 13.7977C27.5527 13.534 28.9381 13.6694 30.1971 14.1866C31.4561 14.7037 32.5322 15.5796 33.2893 16.7033C34.0464 17.8271 34.4505 19.1482 34.4505 20.4997C34.4505 22.312 33.7246 24.0501 32.4324 25.3316C31.1403 26.6131 29.3877 27.3331 27.5603 27.3331Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9983_193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadFilter);
export default __webpack_public_path__ + "static/media/unread-filter.f1c8a2123b3ac19b2c8cbe432ee4d8ac.svg";
export { ForwardRef as ReactComponent };